import React from "react";
import { Grid, Typography, Box } from "@mui/material";

const SYNC_OPTIONS = [
  { key: "productInfo", label: "Product information", description: "Name, description, category, brand details" },
  { key: "images", label: "Images", description: "Product image, videos" },
  {
    key: "specsAndTracklisting",
    label: "Specs & tracklisting",
    description: "key features, specifications of product",
  },
  { key: "extendedContent", label: "Extended content", description: "Extended description of product" },
  { key: "dimensions", label: "Dimensions", description: "Weight, size, packaging dimensions" },
];

type SyncOptionsSelectProps = {
  selectedOptions: string[];
  setSelectedOptions: (cb: (prev: string[]) => string[]) => void;
};

type SyncOptionCheckboxProps = {
  opt: (typeof SYNC_OPTIONS)[number];
  selectedOptions: string[];
  setSelectedOptions: (cb: (prev: string[]) => string[]) => void;
};

const SyncOptionCheckbox: React.FC<SyncOptionCheckboxProps> = ({ opt, selectedOptions, setSelectedOptions }) => (
  <Box sx={{ display: "flex", alignItems: "flex-start", mb: 2 }}>
    <input
      type="checkbox"
      id={opt.key}
      checked={selectedOptions.includes(opt.key)}
      onChange={() => {
        setSelectedOptions((prev) => (prev.includes(opt.key) ? prev.filter((k) => k !== opt.key) : [...prev, opt.key]));
      }}
      style={{
        accentColor: "#008000",
        width: 16,
        height: 16,
        marginRight: 5,
        marginTop: 5,
        cursor: "pointer",
      }}
      aria-label={opt.label}
    />
    <Box>
      <label htmlFor={opt.key} style={{ fontSize: 16, cursor: "pointer" }}>
        {opt.label}
      </label>
      <Typography variant="body2" sx={{ color: "#666", fontSize: 12, mt: 0.5 }}>
        {opt.description}
      </Typography>
    </Box>
  </Box>
);

export const SyncOptionsSelect: React.FC<SyncOptionsSelectProps> = ({ selectedOptions, setSelectedOptions }) => {
  return (
    <Grid item xs={12}>
      <Box
        sx={{
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
          p: 0,
          mt: 2,
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        <Box sx={{ borderBottom: "1px solid #e0e0e0", background: "#f5f5f5", px: 3, py: 2 }}>
          <Typography variant="h6" fontWeight={700}>
            Sync options
          </Typography>
        </Box>
        <Box sx={{ px: 3, py: 2 }}>
          <Grid container spacing={0}>
            <Grid item xs={12} sm={6}>
              {SYNC_OPTIONS.slice(0, 3).map((opt) => (
                <SyncOptionCheckbox
                  key={opt.key}
                  opt={opt}
                  selectedOptions={selectedOptions}
                  setSelectedOptions={setSelectedOptions}
                />
              ))}
            </Grid>
            <Grid item xs={12} sm={6}>
              {SYNC_OPTIONS.slice(3).map((opt) => (
                <SyncOptionCheckbox
                  key={opt.key}
                  opt={opt}
                  selectedOptions={selectedOptions}
                  setSelectedOptions={setSelectedOptions}
                />
              ))}
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Grid>
  );
};
